import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { SAVED_SCREENS_QUERY_KEY } from "./useSavedScreens";

type CreateSavedScreenBody = components["schemas"]["CreateSavedScreenBody"];
type SavedScreenResponse = components["schemas"]["SavedScreenResponse"];

export function useCreateSavedScreen() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<SavedScreenResponse, Error, CreateSavedScreenBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/screens", { body });
      if (error !== undefined) {
        throw new Error("Failed to create saved screen");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_SCREENS_QUERY_KEY });
    },
  });
}
